<template>
  <div class="c-audio-player__wrapper">
    <audio
      ref="player"
      crossorigin=""
      :controls="type === 'native'"
      class="c-audio-player__native"
      @play="isPlay = true"
      @pause="isPlay = false"
      @timeupdate="updateCurrentTime"
      @durationchange="updateDurationTime"
      @volumechange="volumeChange"
      @loadeddata="init"
    >
      <source :src="fileUrl" :type="fileType">
      <p>Your browser doesn't support HTML5 audio. Here is
        a <a :href="fileUrl">link to the audio</a> instead.</p>
    </audio>

    <CustomAudioPlayerFull
      v-if="type !== 'native'"
      :is-play="isPlay"
      :current-time="currentTime"
      :duration="duration"
      :muted="muted"
      :volume="volume"
      :type="type"
      @toggle-play="togglePlay"
      @toggle-muted="toggleMuted"
      @update-current-time="updatePlayerCurrentTime"
      @update-volume="updateVolume"
    />
  </div>
</template>

<script>
import CustomAudioPlayerFull from './src/CustomAudioPlayerFull'

export default {
  name: 'fh-audio-player',

  components: {
    CustomAudioPlayerFull
  },

  data() {
    return {
      isPlay: false,
      currentTime: 0,
      duration: 0,
      muted: false,
      volume: 1
    }
  },

  mounted() {
    if (this.startTime) {
      this.currentTime = this.startTime
    }

    this.muted = this.$refs.player.muted
  },

  props: {
    type: String,
    startTime: Number,
    fileUrl: String,
    fileType: String
  },

  watch: {
    fileUrl() {
      const isPlaying = this.$refs.player.duration > 0 && !this.$refs.player.paused

      if (isPlaying) this.$refs.player.pause()
      this.$refs.player.load()
      if (isPlaying) this.$refs.player.play()
    }
  },

  methods: {
    volumeChange(ev) {
      const { volume, muted } = ev.target

      this.volume = volume
      if (volume === 0 & !muted) this.toggleMuted()
      if (volume > 0 & !muted) this.muted = false
    },

    updateCurrentTime(ev) {
      this.currentTime = ev.target.currentTime
      this.$emit('timeupdate', ev.target.currentTime)
    },

    updatePlayerCurrentTime(time) {
      this.$refs.player.currentTime = time
    },

    updateDurationTime(ev) {
      this.duration = ev.target.duration
    },

    togglePlay() {
      if (!this.isPlay) {
        this.$refs.player.play()
      } else {
        this.$refs.player.pause()
      }
    },

    toggleMuted() {
      this.$refs.player.muted = !this.$refs.player.muted
      this.muted = this.$refs.player.muted
      // if no volume on unmuted player, move scale to half like native player
      if (!this.muted && this.$refs.player.volume === 0) this.$refs.player.volume = 0.5
    },

    updateVolume(value) {
      this.volume = value
      this.$refs.player.volume = value
    },

    init() {
      this.$emit('init', this.$refs.player)
    }
  }
}
</script>
